import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const AboutSection = () => {
  const stats = [
    { value: "+7.200", label: "Clínicas" },
    { value: "+102.000", label: "Pacientes" },
    { value: "+365", label: "Milhões financiados" },
    { value: "2018", label: "Desde" }
  ];

  return (
    <section className="section-padding bg-white relative">
      <div className="container-custom">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-drcash-maastricht-blue mb-6">
              Sobre a Dr.Cash
            </h2>
            <div className="h-1 w-20 bg-gradient-to-r from-drcash-caribbean-green to-drcash-tiffany-blue rounded-full mb-6"></div>
            <p className="text-lg text-drcash-sapphire-blue mb-6">
              Evoluímos de boletos parcelados para um hub completo de soluções financeiras
            </p>
            <p className="text-gray-700 mb-6">
              Nascemos com o propósito de democratizar o acesso à saúde através do financiamento 
              de procedimentos. Hoje, nossa missão se expande para oferecer um ecossistema financeiro 
              completo para clínicas e profissionais de saúde.
            </p>
            <p className="text-gray-700 mb-8">
              Combinamos tecnologia e conhecimento especializado do setor para desburocratizar processos 
              financeiros e maximizar resultados para nossos parceiros.
            </p>
            
            <Link 
              to="/sobre" 
              className="inline-flex items-center text-drcash-caribbean-green font-medium hover:underline"
            >
              Conheça nossa história completa
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </div>
          
          <div className="grid grid-cols-2 gap-6">
            {stats.map((stat, index) => (
              <div 
                key={index} 
                className="bg-white p-6 rounded-xl shadow-lg card-hover border border-gray-100 text-center"
              >
                <h3 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-drcash-caribbean-green to-drcash-tiffany-blue mb-2">
                  {stat.value}
                </h3>
                <p className="text-drcash-sapphire-blue font-medium">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      <div className="absolute top-0 right-0 shape-dot-grid opacity-10 w-64 h-64"></div>
      <div className="absolute bottom-0 left-0 shape-dot-grid opacity-10 w-64 h-64"></div>
    </section>
  );
};

export default AboutSection;
